
import pic from '@/utils/pic'
const { icon1, icon2, icon3, langzh, langen, langtw, langjp,langar, langxby,langdy,langfy,langhy,langty,langyn,zhsz, jtrz, sfrz, iconchecked, iconcheck,icon1_01,icon1_02,icon1_03,icon1_04,banner01,banner02,banner03 } = pic

export default {
  currency: {
    bb: '交換',
    bba: '交換口座',
    hy: '契約',
    jg: 'オプション取引',
    jg1: '先物',
    hya: '契約アカウント'
  },
  home:{
    user:'ユーザーの一般的な選択',
    start:'取引を開始する',
    trading:'トレーディング商品',
    fee:'最低手数料',
    co:'コ',
    varieties:'取引品種',
    leading:'Web3 の革新と探求をリード',
    market:'トレーディング商品の市場動向',
    explore:'無限の可能性を探る',
    newcurrency:'新しい通貨サブスクリプション機能がオンラインに登場！',
    alimited:'新しいコインはオンラインで、可能性があると思われる新しいコインをここで購入できます',
    get_start:'始めましょう',
    ai_coin:'AIコイン獲得計画進行中',
    ai_text:'AIでコイン稼ぎを始めよう、安定収入、高還元率で寝ながらコインが稼げる',
    loan:'ローン機能はオンラインです',
    loan_text:'お金がない時でも申し込めば最短即日で融資してもらえます',
    mobile_pc:'手看護師がモバイル PC で使用',
    pc_anytime:'いつでもどこでも取引を始めましょう:',
    pc_text:'当社は、50 を超えるテクニカル指標とディスク分析ツールなど、強力なチャート分析ツールを提供します。安全で信頼性が高く、使いやすいレバレッジとハイレバレッジ機能は、オンライン投資の標準プラットフォームとなっています。',
    mobile_down:'クリックしてダウンロード',
    mobile_android:'アンドロイドマーケット',
    mobile_ios:'アップルストア',
    open_text:'只実際の取引口座を申請したり、デモ口座を 3 分の 1 のコストで無料で試したりすることができます。',
    open_account:'アカウント',
    tocomplete:'完了する',
    walletlogin:'ウォレットへのログイン'
  },
  index: {
    h24: '24時間の額',
    header_title: ['デジタル資産取引を選択する ' + window.GLOBAL.LANG_TITLE.zh],
    header_small_title:'ワンストップのブロックチェーンデジタル資産取引を完了する',
    header_msg: '安全-安定-信頼できる',
    register_title: '登録する ' + window.GLOBAL.LANG_TITLE.zh + ' グローバルアカウントは取引の旅を開始します',
    register_pl: 'eメールまたは携帯電話番号を入力してください',
    register: '登録',
    featureTitleWhy: 'なぜ私たちを選ぶのか',
    featureTitle: '安全，安定，信頼性',
    featureMsg: '',
    featureList: [
      { icon: icon1, title: '安全なウォレットテクノロジー', msg: ['コールドウォレットとホットウォレットのテクノロジーは世界トップのセキュリティチームによって開発されており、コインの紛失は一度もありません。',''] },
      { icon: icon2, title: '豊富な暗号資産事業', msg: ['サポートスポットや複数のデリバティブ取引などは、暗号化された資産の世界へのあなたの個人的なスチュワードです。',''] },
      { icon: icon3, title: '世界中に分散している顧客', msg: ['世界130を超える国または地域のユーザーに、暗号化された資産サービスの全範囲を提供します。', ''] }
    ],
    bannerList: [
      {icon:banner01,title: "業界をリードするセキュリティと安定性の提供に取り組んでいます",msg:["投資家の資産の安全を保護するスマートコントラクト", "実際の取引実績", "24時間サービス保証"]},
      {icon:banner02,title: "簡単な操作ですぐに売買したい",msg:["簡単な取引画面", "アカウントの残高にすぐに反映されます", "ほとんどの暗号通貨は取引できます"]},
      {icon:banner03,title:"決済契約取引で積極的に利益を上げたい",msg:["同時に口座を開設","多数の取引先物への戦略的投資","24取引可能1日何時間,1年365日,週末でも"]}
    ],
    featureList2: [
      {icon: icon1_01,title: "透明性と開放性",msg:["ブロックチェーンとスマートコントラクトの特性を使用し,チェーンでのトランザクションパフォーマンスを実現し,スマートコントラクトを使用して投資家の資産の安全を確保する", ""] },
      {icon: icon1_02,title: "Smart Investment",msg:["トップのクオンツアナリストが提供する多様な戦略により,自由に選択できます", ""]},
      {icon: icon1_03,title: "リスクグレーディング",msg:["各投資家のさまざまなリスクと資産管理の好みに基づいて分散投資商品を設計し,投資のしきい値を効果的に排除する", ""]},
      {icon: icon1_04,title: "多様な製品",msg:["さまざまなタイプのユーザー投資ニーズと柔軟なプラットフォームメカニズムを提供し,市場よりも優れた革新的な金融サービスを生み出し続けます", ""]}
    ],
    featureTitle2: 'いつでもどこでもマルチプラットフォーム端末トランザクション',
    featureMsg2: 'iOSとAndroidの複数のプラットフォームをカバーし、フルサービス機能をサポートします',
    tab: ['主流の通貨', '24H 増加リスト'],
    thead: ['ペア', '最新価格', 'その日の最高価格', 'その日の最低価格', '増加リスト', '24時間ボリューム', 'オペレーティング'],
    more: 'もっと >',
    btn: '取引',
    dealsTitle: 'ワンストップトレーディングサービス',
    dealsTab:[
      { title: '交換', content: '交換は、他の通貨を購入するための評価の単位としてUSDTを使用して、デジタル資産間の交換のためのものです。'+window.GLOBAL.LANG_TITLE.zh+'取引所は、ビットコイン、イーサリアム、ライトコインなどのデジタル資産のリアルタイムフェッチをサポートしています。', src:'/static/image/deals-1.jpg', path: '' },
      { title: '契約', content: 'デジタル通貨の金融デリバティブは、収入を得るためにロングまたはショートの販売契約を購入する選択をサポートするだけでなく、操作が簡単で、期限が切れることはありません。'+window.GLOBAL.LANG_TITLE.zh+'この契約には、最大100倍のレバレッジを備えた高度なリスク管理システムがあります。', src:'/static/image/deals-2.jpg', path: '' }
    ]
  },
  market: {
    tab: ['お気に入り', '契約', '交換'],
    thead: ['通貨', '最新価格', '24時間変更', '24H 最低価格', '24H最高価格','24Hボリューム', '操作'],
    nodata: 'データなし'
  },
  footer: {
    p: '©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
    dd: [
      {
        dt: "当社について",
        dd: [{ title: "会社概要", id: 1 }, { title: "ヘルプセンター", type: 'help' }]
      },
      {
        dt: "ユーザーサポート",
        dd: [
          { title: "ユーザー規約", id: 3 },
          { title: "個人情報保護方針", id: 5 }
        ]
      },
      {
        dt: "お問い合わせ",
        icon: true
      }
    ],
    terms: "利用規約",
    serve: "仕える",
    product: "製品",
  },
  nav: {
    btn: ["ログインする", "登録", "資産運用管理","ダウンロードApp"],
    nav: [
      // { title: "ホーム", path: "/index",name: 'index' },
      // { title: "交換", path: "/deal",name: 'deal' },
      { title: "市場", path: "/market",name: 'market' },
      { title: "トレード", path: "/preciousMetal", name: 'preciousMetal'},
      // { title: "交換", path: "/deal", name: 'deal'},
      // { title: "契約", path: "/deal_c", name: 'deal_c' },
      // { title: "暗号通貨", path: "/deal_jg", name: 'deal_jg' },
      // { title: "AI コインを獲得", path: "/profit_index",name: 'profit_index' },
      { title: "資産管理", path: "/profit_index",name: 'profit_index' },
      { title: "アクティビティ", path: "/sign",name: 'sign' }
    ],
    nav2: [{ title: "私の資産", path: "/asset" }],
    menus: [
      { icon: langzh, title: "ユーザーセンター", path: "/setting" },
      { icon: langen, title: "ログアウト" }
    ],
    lang: [
      { icon: langen, lang: "English", key: 'en' },
      { icon: langxby, lang: "España", key: 'es' },
      { icon: langfy, lang: "français", key: 'fr' },
      { icon: langdy, lang: "Deutsche", key: 'de' },
      { icon: langjp, lang: "日本語", key: 'jp' },
      // { icon: langar, lang: "عربي", key: 'ar' },
      { icon: langhy, lang: "한국어", key: 'kr' },
      { icon: langty, lang: "ไทย", key: 'th' },
      { icon: langyn, lang: "Tiếng Việt", key: 'vn' },
      { icon: langzh, lang: "简体中文", key: 'zh' },
      { icon: langtw, lang: "繁體中文", key: 'tw' },
    ]
  },
  download:{
    "xz": "下载"
  },
  // ログインする
  // login: {
  //   login: '欢迎ログインする',
  //   msg: 'ログインしたアカウントを入力してください',
  //   list: ['携帯電話/Eメール', 'パスワード', 'パスワードを忘れましたか？', 'ログインする', 'アカウントがありません、今すぐログインしてください'],
  //   message: 'アカウントまたはパスワードを空にすることはできません'
  // },
  register: {
    dl: ['お使いの携帯電話を登録します', 'メール登録'],
    title: 'アカウントを登録',
    country: '国籍',
    country_info: '登録後に国籍情報を変更することはできませんので、必ず誠実に選択してください',
    account: '口座番号',
    code_text: '検証コード',
    code_btn: '検証コードを取得',
    code_unit: 's',
    code_no_data: '確認コードを入力する必要があります',
    password_text: 'パスワードをもう一度入力してください',
    password_again_text: 'もう一度パスワードを入力してください',
    pid_text: '招待コード',
    pid_pl: 'オプション',
    invitation_code_no_data: '招待コードが必要です',
    xy: 'ユーザー規約',
    xy_no_checked: '同意を選択してください',
    agree:'私は読んで同意しました',
    register_btn: '登録',
    bz: ['登録後に国籍情報を変更することはできませんので、誠実に選択してください。 ','確認メールがスパムと誤認される可能性がありますので、よくご確認ください。', '保管してください' + window.GLOBAL.LANG_TITLE.zh + 'アカウント番号とログインパスワード。', '他のウェブサイトと同じログインパスワードを使用しないでください。'],
    account_no_data: 'アカウント番号は空欄にできません',
    code_no_equality: '確認コードが等しくない',
    password_no_data: 'パスワードを空白にすることはできません',
    password_no_equality: '2つのパスワードが等しくない'
  },
  // 設定パスワード
  bindmpwd: {
    title: '設定パスワード',
    account: '口座',
    code_text: '検証コード',
    code_btn: '検証コードを取得',
    code_unit: 's',
    password_text: 'パスワードをもう一度入力してください',
    password_again_text: 'パスワードをもう一度入力してください',
    code_no_data: '確認コードを入力する必要があります',
    code_no_equality: '確認コードが等しくない',
    password_no_data: 'パスワード不能为空',
    password_no_equality: '2つのパスワードが等しくない',
    bindmpwd_btn: '確認',
    phone_no_data: '電話番号を空白にすることはできません',
    password_login_text: '请输入ログインするパスワード',
    password_trade_text: 'パスワードの長さ6桁',
    password_again_tarde_text: 'パスワードの長さ6桁',
  },
  // 忘记パスワード
  forgetpwd: {
    title: ['パスワードを変更する', 'パスワードをお忘れですか'],
    account: '口座',
    code_text: '検証コード',
    code_btn: '検証コードを取得',
    code_unit: 's',
    password_text: 'パスワードをもう一度入力してください',
    password_again_text: 'パスワードをもう一度入力してください',

    phone_no_data: '電話番号を空白にすることはできません',

    account_no_data: 'アカウント番号は空欄にできません',
    code_no_data: '確認コードを入力する必要があります',
    code_no_equality: '確認コードが等しくない',
    password_no_data: 'パスワード不能为空',
    password_no_equality: '2つのパスワードが等しくない',
    forgetpwd_btn: '確認'
  },
  // 绑定手机号码
  bindphone: {
    title: '携帯電話番号をバインドする',
    phone_text: '電話番号',
  },
  person: {
    more: 'さらに読み込む',
    no_more: 'これ以上のデータはありません',
    index_center:"ユーザーセンター",
    index_menus: [
      { icon: zhsz, title: "アカウント管理", path: '/setting' },
      { icon: sfrz, title: "KYC認証", path: '/sfyz' },
      { icon: sfrz, title: "一次認証", path: '/smauth' },
      { icon: sfrz, title: "二次認証", path: '/seniorauth' },
      { icon: jtrz, title: "アドレス認証", path: '/dzrz' },
      { icon: jtrz, title: "暗号通貨", path: '/kjmbSelect' },
      { icon: jtrz, title: "クレジットスコア", path: '/credit' },
      { icon: jtrz, title: "記録", path: '/deallog' },
      { icon: jtrz, title: "預金記録", path: '/cbjl' },
      { icon: jtrz, title: "撤退記録", path: '/tbjl' },
    ],
    cbtb: '預入`出金',
    jymx: '取引の詳細',
    xyf: {
      'title': 'クレジットスコア',
      'pgsj': '評価時間'
    },
    smrz:{
       title:'本人確認' ,
       sure_title:'合格しました本人確認',
       zj_type:'有効なIDの種類' ,
       zj_info:['1.認証情報が確認されると、変更できません。「、」を正直に入力してください。2。認証された実名情報を再認証することはできません。'],
       zj_name:'本名' ,
       zj_num:'ID番号' ,
       zj_btn:'確認' ,
       zj_rebtn:'再確認' ,
       zj_sebtn:'二次認証' ,
       zj_type_array:[{name:'IDカード',type:'idcard'}],
       idCardArr: [
        {
            id: 1,
            name: "IDカード"
        },
        {
            id: 2,
            name: "パスポート"
        },
        {
            id: 3,
            name: "運転免許証"
        },
        {
            id: 4,
            name: "居住許可証"
        },
        {
            id: 5,
            name: "その他"
        }
       ],
       zj_data:{city:'国籍を空にすることはできません',type:'クレデンシャルタイプを空にすることはできません',name:'氏名は空欄にできません',zj_num:'ID番号は空欄にできません'},
       zsxm: '本名',
       qsrzsxm: '本名を入力してください',
       zjlx: '有効なIDの種類',
       qxzzjlx: 'IDの種類を選択してください',
       sfz: 'IDカード',
       zjhm: 'ID番号',
       qsrzjhm: 'ID番号を入力してください',
       sczjz: 'ドキュメントをアップロードする',
       zjzm: 'IDカードの表面の写真をアップロードする',
       zjfm: 'IDカードの裏面の写真をアップロードする',
       qsczjzm: 'IDカードの表面の写真をアップロードする',
       qsczjfm: 'IDカードの裏面の写真をアップロードする',
       scqmz: 'IDカードと個人署名をアップロードする',
       qscscqmz: 'IDカードと個人署名をアップロードする',
       zj: [
         {
           id: 1,
           title: 'IDカード'
         },
         {
           id: 2,
           title: 'パスポート'
         },
         {
           id: 3,
           title: 'その他'
         },
       ],
       tj: '提出',
       shz: '審査中',
       shtg: '承認'
    },
    gjrz:{
      title:'二次認証',
      zj_info:['1. 画像は、8MBより小さく、JPG、JPEG、またはPNG形式がサポートされます。','2. IDカードは、写真が明瞭で、修正や妨害があってはなりません。 IDカードの番号および所有者の氏名がはっきり映っていなければなりません。','3. 帽子をかぶっている写真は不可で、メークアップをしていないものが推奨されます。顔の特徴がはっきりと認識できるもので、両腕が全部露出しているものでなければなりません。'],
      zj_img:['/static/image/User_Center_Front_view.png','/static/image/User_Center_Back_Shot.png','/static/image/User_Center_Full_picture.png'],

    },
    zhgl:{
      title:'セキュリティ設定',
      bind:[{bind_title:'パスワードを再設定する',bind_name:'Eメール'},{bind_title:'設定取引パスワード',bind_name:'Eメール'}]
    },
    wdtg:{
      own_code:'招待コード',
      own_code_url:'招待リンク',
      own_push_title:'私の昇格',
      own_push_content:['招待収入の合計','招待数','人'],
      own_push_content_profit:['一级邀请收益','二级邀请收益','三级邀请收益','四级邀请收益'],
      own_push_content_num:['一级邀请人数','二级邀请人数','三级邀请人数','四级邀请人数'],
      own_push_profit_title: ['ID', '所得', '備考','時間を追加する'],
      own_push_num_title: ['ID', '名称', '电话','時間を追加する'],
    },
    jyzt_td: ['時間', '詳細', '量'],
    cbjl_td: ['時間', '通貨', '額','状態'],
    sfrz_txt: ['本人確認', 'レビューを送信しました。結果が出るまでお待ちください', '二次認証に合格しました', 'IDカードの前面', 'IDカードの裏面', '認証','認証に失敗しました。再認証してください'],

    zhsz_txt: ['アカウントのセキュリティレベル: #', 'アカウントのセキュリティレベル: #，口と座席の安全を確保するために、より多くの情報を改善する'],
    zhsz_m: '強い',
    zhsz_n: '弱い',
    zhsz_p: '危険な',
    zhsz_detailList: [
      // { icon: iconchecked, title: 'アカウント招待コード', value: '', btn: '复制招待コード', class: 'copy', event: 'copy' },
      // { icon: '/static/image/User_Center-email.png', title: 'Eメール', value: '用于ログインする、出金、安全設定时使用', value2:'',btn: '绑定', btn2: '已绑定', path2: '/bindphone' },

      // { icon: '/static/image/User_Center-phone.png', title: '手机', value: '用于提现，修改パスワード，安全設定时用以收取验证短信', value2:'', btn: '绑定', btn2: '已绑定', path2: '/bindphone' },
      { icon: '/static/image/User_Center-password.png', title: 'ログインするパスワード', value: 'インターネットアカウントは盗まれる危険性があります。アカウントのセキュリティを保護するために、定期的にパスワードを変更することをお勧めします。',value2:'', btn: '変更する',bind_email:'最初にEメールまたは携帯電話をバインドしてください', path: '/forgetpwd?type=changepwd' },
      { icon: '/static/image/User_Center-password.png', title: '取引パスワード', value: '設定パスワード', btn: '設定', path: '/bindmpwd' }
    ],
    sksz_txt: ['コレクションの設定', 'セーブ'],
    sksz_list: [
      { label: "ユーザー名:", pl: "ユーザー名を入力してください", key: "name" },
      { label: "銀行口座の氏名:", pl: "銀行口座の氏名を入力してください", key: "bank_name" },
      { label: "銀行口座:", pl: "口座番号を入力してください", key: "bank_number" },
      { label: "Alipayアカウント:", pl: "Alipayアカウントを入力してください", key: "alipay_account" },
      { label: "WeChatのニックネーム：", pl: "WeChatのニックネームを入力してください", key: "weixin_nickname" },
      { label: "WeChatアカウント：", pl: "WeChatアカウントを入力してください", key: "weixin_account" }
    ]
  },
  pasination: {
    first: 'ホーム',
    prev: '前のページ',
    next: '次のページ',
    last: '最後のページ',
    no_data: 'データなし',
  },
  asset: {
    title: '私の資産',
    zjhz: '资金划転',
    cb: '預入',
    gz: 'USDT估值',
    atnv: [],
    zh_title: '変換された総資産：',
    index_title: '資産',
    address_title: '通貨',
    address_txt: ['選んでください', '出金先', 'コンテンツを入力してください', '備考', 'アドレスリスト'],
    address_btn: ['追加', 'セーブ', '削除', '編集'],
    address_td: ['通貨', '出金先', '備考', '操作'],
    currency_td: ['通貨', '利用可能', 'フリーズ', '換算済額'],

    table_title: '総資産：',
    table_address_title: '出金先管理',
    table_td: ['通貨', '利用可能', 'フリーズ', '換算済額', '操作'],
    table_btn: ['預入', '出金', '記録', '取引'],

    money_text: ['出金先', '選んでください', '額', '利用可能：', '手数料',
      '入金量', '取引パスワード','タグ(Memo)','最低'],
    money_btn: '出金',
    xzbz: '通貨選択',
    money_msg: ['リマインダ：', '', '','','',''],

    recharge_title: '預入住所',
    recharge_btn: ['コピー', 'QRコード', '預入'],
    recharge_text: ['額', 'リマインダ：', 'この通貨以外の資産を上記住所に追加しないでください。資産の出金ができなくなります。', 'USDT預入仅支持simple send的方法，使用その他方法（send all）的預入暂时无法上账，请您谅解。', '凭证', 'バウチャーの説明(オプション)','チェーン名'],

    record_title: '财务記録',
    record_td: ['額', '記録', '時間'],

    transfer_title: '転送',
    transfer_btn: ['すべて', '転送'],
    transfer_text: ['从', '至', '请输入転送額', '利用可能：'],
    "bq": "ラベル(Memo)",
    "qsrbq":"ラベルを入力してください",
    "yhktx":"銀行カードの引き出し",
    "yhmc": "銀行名",
    "qsryhmc": "銀行名を入力してください",
    "yhzh": "銀行口座",
    "qsryhzh":"銀行口座番号を入力してください",
    "gjhkdm": "国際送金コード",
    "qsrgjhkdm":"国際送金コードを入力してください",
    "yhdz": "銀行の住所",
    "qsryhdz":"銀行の住所を入力してください",
    "skrxm": "支払者名",
    "qsrskrxm":"お支払い受取人の名前を入力してください",
    "skrdh": "受取人の電話",
    "qsrskrdh":"お支払い受取人の電話番号を入力してください",
    "skrdz": "受取人の住所",
    "qsrskrdz":"受取人の住所を入力してください"
  },
  text: {
    btn: '戻る',
    login: 'サインインしてください'
  },
  deal: {
    chooseType: '手数料の種類',
    choose: '選んでください',
    balance: '残高：',
    account: ['口座', '利用可能', '/フリーズ', '転送'],
    dir: ['購入', '売却'],
    dir2: ['利用可能', '売却可能'],
    cs: 'お気に入り',
    sxf: '手数料率',
    jye: '取引金額',
    sc_list: ['市場', 'ペア', '増加する'],
    sc_h: ['Latest', '24H Lowest', '24H Highest', '24H Vol.'],
    td_lt: ['通貨', '最新価格', '増加する'],
    k_line_txt: ['≈', '', '増加する', '最高価格', '最低価格', '24Hの額'],
    tabListLTitle: ["現在の手数料", "履歴（完了済）"],
    tabListLEntrust: ["購入", "売却"],
    tabListRTitle: ["リミット取引", "市場価格取引"],
    table_btn: ['キャンセル'],
    index_td_l: ['時間', '取引パートナー', '額', '価格', '操作'],
    index_td_r: ['最新価格', '方向', '価格', '額'],
    index_td_r2: ['最新取引', '時間', '価格', '取引量'],
    table_txt: ['処理済額', 'キャンセル済み'],

    db_1_txt: ['利用可能', '購入价', '売却价', '購入量', '売却量', '取引金額', '市場で最高の価格で購入する', '市場で最高の価格で販売する', '購入手', '売却手'],
    db_2_txt: ['価格', 'レバー', '選んでください', '手数料', '1ロット相当', '手', '契約市值', '保証金', '市場で最高の価格で購入する', '市場で最高の価格で販売する'],
    pathList: ['契約記録', '取引記録'],
    db_btn: ['購入(ロング)', '売却(ショート)'],
    tabListLTitle2: ['現在の手数料'],

    lt_btn: ['ワンクリック清算', 'テイクプロフィット・ストップロス', '清算', '提出', '戻る'],
    lt_txt: ['リスク率：', '総収益：'],
    lt_td: ['種類','レバレッジ', 'ポジション価格', '現在価格', '保証金', 'テイクプロフィット価格', 'ストップロス価格', '開始時間', '手数料', '総収益', '操作'],
    lt_dl: ['テイクプロフィット・ストップロス', 'テイクプロフィット価格', 'ストップロス価格'],

    lt_0_btn: ['キャンセル'],
    lt_0_td: ['联系方式', '通貨', '額', '現在価格', '手数料', '操作'],

    lt_1_btn: ['清算'],
    lt_1_txt: ['終了中'],
    lt_1_td: ['種類', 'ポジション価格', '現在価格', '保証金', 'テイクプロフィット価格', 'ストップロス価格', '開始時間', '手数料', '総収益', '操作'],
    node_data: 'データなし',

    lt_3_txt: ['已平仓', '爆仓'],
    lt_3_td: ['種類', '手数料', 'ポジション価格', '終値', 'テイクプロフィット価格', 'ストップロス価格', '保証金', '利用可能保証金', '開始時間', '清算時間', '手数料',
      '総収益', '操作'],

    lt_4_txt: ['キャンセル済み'],
    cm: ['公開時間', '発行番号', '総循環', '合計金額', '公式ウェブサイト','ホワイトペーパー','情報'],
    qsrsl: '金額を入力してください',
    qsrss: 'ロットを入力してください',
  },
  notice:{
      notice_title:'アナウンスセンター',
  },
  bzhl:{
    title: 'AI コインを獲得',
    title1: 'AIによる定量化',
    ttzbt: '毎日お金を稼ぎ続ける',
    wdtg: 'エスクロー注文',
    zztgdzj: '管理中の資金',
    yjjrsy: '毎日推定',
    ljsy: '累計収益',
    tgzdd: '管理中の注文',
    tgdd: '管理中の注文',
    t1: '低リスクで安定した財務管理、必要に応じていつでも償還可能',
    t2: 'あなたの無料のお金の管理アシスタント',
    cljxcp: '商品サイクル',
    dbxe: 'シングルリミット',
    rsyl: '日次収益率(%)',
    rsyl2: '日次収益率：',
    zq: 'サイクル',
    qmr: '購入',
    ckgd: 'もっと',
    cpgk: '商品概要',
    pxsj: '配当時間',
    tgzj: '管理資金',
    tqsh: '早期償還',
    cpld: '商品のハイライト',
    cpgz: 'ルール',
    cont: 'USDTの収益は、プラットフォームでUSDTをホストすることにより、プラットフォームの専門家チームによって管理されます。参加者は、ファンドのホスティング期間中にプラットフォームの収益分配を取得できます。これはいつでもアクセスでき、安全で便利です。',
    zj: '100%資金',
    aqbz: 'セキュリティ',
    jjrsy: '休日の収入',
    bjd: '途切れない',
    cgcrh: '入金が成功した後',
    dtqx: '当日の利息を計算する',
    ljzr: '今すぐ転送',
    xqglgj: '無料のお金の管理ツール',
    ddh: '注文番号',
    tgje: '管理額',
    tgsj: 'サイクル',
    yhl: '管理額/管理時間',
    xdsj: '注文時間',
    zt: '状態',
    fh: '戻る',
    qrnhsy: '7日間の年収',
    ygy: '1ヶ月',
    bn: '半年',
    yn: '1年',
    yuan: '$',
    tzfx: '投資リスク',
    shsc: '償還時間',
    di: '低',
    yggzr: 'ある営業日',
    msgsxf: '無料サブスクリプションロット',
    mr: '毎日',
    dqfh: '満期時配当',
    ljgm: '今すぐ購入する',
    tgz: '管理中の注文',
    sh: '償還済',
    ywc: '完了',
    ysh: '償還済',
    all: 'すべて',
    "xzbzts": "シンプルで安全。 配当は複数の通貨で選択できます",
    "qtbz": "その他のコイン"
  },
  pay:{
    qsrjymm: '6桁のパスワード',
    tbmmts: 'ユーザーセンターにアクセスして、トランザクションパスワードを設定してください',
  },
  tips:{
    qxztbdz: '出金住所を入力してください',
    qsrtbsl: '出金通貨の額を入力してください'
  },
  statusText: ['失敗','処理','成功'],
  dzrz: {
    title: 'アドレス認証',
    sdddz: '公共料金の請求先住所',
    zdtpsc: '請求書画像のアップロード',
    qsrsdddz: '住所情報を入力し、公共料金またはブロードバンドアドレスの請求書を提出する必要があります',
    qsczdtp: '請求書の写真をアップロードしてください',
    status: ['審査中','承認'],
    qd: '確認',
  },
  jgcc: {
    wtgd: '現在の手数料',
    cj: '取引成功',
    jj: '情報',
    zc: '現在',
    lszc: '履歴',
    qblx: '全種類',
    xj: '現在の価格',
    sj: '時間',
    fx: '方向',
    jg: '価格',
    sl: '額',
    jgsj: 'スワップ時間',
    gmj: '購入価格',
    jsj: '決済価格',
    yk: '総収益',
    xq: '詳細',
    "mz": "強気",
    "md": "弱気",
    dqye: '現在の残高',
    gb: 'クローズ',
    jxxd: '注文を続ける',
    qrxd: '確認',
    ddqr: '注文確認',
    sxf: '手数料',
    kyye: '残高',
    jypz: '取引の種類',
    jyfx: '取引の方向',
    tzje: '投資価格',
    tzjeTips: '最低価格 0',
    dqsj: '満期時間',
    jssj: '配当時間',
    gmsj: '購入時間',
    sy: '収益',
    zxje: '最小額 ',
    shi: 'H',
    fen: 'M',
    miao: 's',
    zdje: "最大額 ",
    qsrje: '金額を入力してください',
    zxtzje: '最小数量 ',
    yebz: '残高不足です',
    xq: '詳細',
    ddz: '待っています',
    jgjl: 'スワップ記録',
    bz: '通貨',
    cz: '操作'
  },
  kjmb: {
    title: '暗号通貨',
    fzcg: '正常にコピー',
    ljmb: '暗号通貨',
    lxkf: 'カスタマーサービスに連絡する'
  },
  news: {
    title: '私のメッセージ',
    "gg":"発表",
    ckxq: '詳細を見る'
  },
  statusTabs:['保留中の注文', '取引中','終了', 'キャンセル済み'],
  "chongzhi":{
    "zy": "重要",
    "cbxx": "トークンデポジット情報",
    "qsrsl": "デポジット額を入力してください",
    "tips2": "1.ウォレット/プラットフォームの互換性：つまり、ネットワークがサポートされています。ターゲットプラットフォームが引き出しネットワークをサポートしていない場合、アセットを取得できません。",
    "tips3": "2.トップアップネットワークとターゲットプラットフォームは同じです。ターゲットアドレスを選択した場合はイーサリアムネットワークですが、トップアップがTRC20スマートチェーンを選択した場合、デジタル資産を取得できない可能性があります。",
    "tips4": "3.再充電する前に、住所と金額が正しいことを確認してください。",
    "tips5": "注意：ブロックネットワークの匿名性とプライバシーのため、間違った情報を入力すると、対応するアセットが失われます。充電先住所と数量をよく確認してください",
    "tips2_1": "•上記の住所に非現地通貨の資産を請求しないでください。請求しないと、資産を取得できません。",
    "tips2_2": "•デジタル通貨は時間内に配信できません。実際の到着時間は、ブロックチェーンの確認速度によって異なります。",
    "tips2_3": "•リチャージアドレスは頻繁に変更されることはなく、リチャージできます。変更があった場合は、ウェブサイトのお知らせまたはメールで通知できるよう最善を尽くします。"
  },
  "tibi":{
    "tbxx": "引き出し情報",
    "qsrbq": "ラベルを入力してください",
    "tbTips1": "•資金の安全を確保するため、アカウントのセキュリティポリシーが変更されたり、パスワードが変更されたりした場合は、手動で引き出しを確認します。スタッフから電話またはメールで連絡が来るまで、しばらくお待ちください。",
    "tbTips2": "•情報が改ざんされたり漏洩したりしないように、コンピューターとブラウザーが安全であることを確認してください。",
    "tbTips3": "•あなたが言及したデジタル資産はワンコインマルチチェーン資産です。どのチェーンから調達することを選択しても、所有する引き出しページに表示されるデジタル資産の合計量が減少することを意味します対応する調達額によって。 ",
  },
  "gjlb": "国のリスト",
  "qxzgjlb": "国/地域を選択してください",
  "mbwt":{
    "title": "セキュリティの問題",
    "mbwt": "セキュリティの問題",
    "problem":[
      {
        "id": 1,
        "title": "あなたの親友は誰ですか？"
      },
      {
        "id": 2,
        "title": "あなたのアイドルは誰ですか？"
      },
      {
        "id": 3,
        "title": "あなたの最も憧れの場所はどこですか？"
      }
    ],
    "qtxda": "お答えください",
    "qsrxmm": "新しいパスワードを入力してください",
    "qqrmm": "パスワードを確認してください",
    "sydqmmcz": "現行パスワードのリセットを使用する",
    "zhmm": "セキュリティの問題パスワードの取得",
    "ysz": "設定",
    "tg": "省略する",
    "tj": "送信する",
    "zyts": "重要：",
    "zytsCont": "秘密の回答と確認コードを開示しないでください。また、パスワードの取得に役立つセキュリティの問題に注意してください。"
  },
  "zc":{
    "zclb": "アセットリスト",
    "zczh": "資産変換",
    "yczc": "0として非表示のアセット"
  },
  "indexNew":{
    "t1": "グローバルリーディング",
    "t2": "デジタル資産サービスプラットフォーム",
    "t3": "完全なワンストップブロックチェーンデジタル資産トランザクション",
    "t4": "携帯電話番号/メール",
    "t5": "今すぐ登録",
    "t6":"GMO グローバルを通じて世界中からのお客様を歓迎します",
    "t7": "暗号化の旅を発見して開始する"
  },
  "newReg":{
    "dl": ['Eメール','携帯電話'],
    "cjzh": "アカウントを作成する",
    "sysjhzyx": "携帯電話番号/メールで登録",
    "yhxy": "&lt;ーザー契約&gt;",
    "yhxy2": "およびユ&lt;ーザー契約&gt;を読み、同意します ",
    "yxgz": "入力したメールボックスがルールを満たしていない",
    "dhgz": "入力した携帯電話番号の形式が間違っている"
  },
  "indexNew2":{
    "t1": "注文で取引",
    "t2": "ビットバンクを使用",
    "t3": "ビットバンクは、ビットコインと暗号化された資産の巧妙に設計された交換です。非常にシンプル、便利、安全、強力です。複数のWebおよびスマートフォンプラットフォームでのトランザクションをサポートします。トランザクションデータとチャートはリアルタイムで更新されます。包括的な市場価格分析は60以上の技術分析ツールを提供します。取引を開始してください",
    "ksjy": "取引開始",
    "ly": "ビットバンクを選択する5つの理由",
    "item1_t1": "取引量のトップ",
    "item1_t2": "No.1 * Crypto Asset Trading Volume",
    "item1_t3": "流動性が高く、快適な（快適な取引経験）取引。12種類の暗号資産を一覧表示します。",
    "item2_t1": "サードパーティによる高い評価",
    "item2_t2": "安全な取引環境",
    "item2_t3": "オフラインのコールドウォレットを使用します。Multisigを使用してハッカーを締め出します。高度なテクノロジーで資産を保護します",
    "item3_t1": "使いやすく信頼性の高いアプリケーション",
    "item3_t2": "使いやすくシンプルなアプリケーション",
    "item3_t3": "豊富な機能を備えた信頼性の高いアプリケーション。トランザクション以外の取引機会を維持できます。",
    "item4_t1": "終日営業",
    "item4_t2": "金を預けることができます",
    "item4_t3": "休日を含む24時間のデポジットサポート！",
    "item5_t1": "スマートフォンとPC",
    "item5_t2": "人間化されたデザイン",
    "item5_t3": "スマートフォンを使用していても、迷わずシンプルで質の高い取引ができます",
    "aqkk": "安全で信頼できる",
    "aqkk2": "ビットバンクビットコイントランザクション",
    "cjzh": "アカウントを作成",
  },
  "xbsg":{
    "title": "ニューコインゾーン",
    "wdsg": "詳細",
    "scts": "ロックアップ日：",
    "sy": "残り",
    "ljsg": "今すぐ購読",
    "ysk": "完売",
    "xzjdy": "今すぐ購読",
    "dy": "購読",
    "fxjg": "発行価格",
    "fxl": "サーキュレーション",
    "ssrq": "上場日",
    "yxqx": "有効期間",
    "qsrsl": "数量を入力してください",
    "syl": "残り",
    "sgrq": "購入日",
    "sgsl": "額",
    "bz": "コイン",
    "yebz": "不十分なUSDTバランス",
    "tgsl": "パス数量",
    "shz": "レビュー中",
    "wtg": "合格しなかった",
    "ytg": "合格しました"
  },
  "wydb":{
    "title": "借りる",
    "db": "借りる",
    "dbz": "借りる",
    "jl": "記録",
    "jdzq": "期間（日）",
    "qhk": "返済",
    "ljdb": "累積（usdt）",
    "dhkbs" :"支払い待ち",
    "jkje": "融資額（usdt）",
    "qsrje": "数量を入力してください",
    "rll": "毎日の金利",
    "hkfs": "返済",
    "dqych": "期限切れ",
    "lx": "興味",
    "fkjg": "貸し手",
    "tpsc": "クレジットローン(画像アップロード)",
    "fwxx": "住宅情報",
    "srzm": "収入の証明（雇用関係）",
    "yhmx": "銀行取引明細書",
    "zjz": "身分証明書の写真",
    "yd": "私は読んで同意しました",
    "xy": "ローン契約を申請する",
    "sqdb": "ローンチェーンに申し込む",
    "gb": "閉鎖",
    "qd": "わかった",
    "ts": "ローン契約の申し込みを確認してください",
    "dbjl": "記録",
    "hkhth": "注文コード",
    "wsh": "未レビュー",
    "yfk": "ローン",
    "sqrq": "適用時間",
    "zq": "サイクル",
    "dbsl": "リブの数",
    "zhke": "支払い合計額",
    "yhkxq": "返済の詳細",
    "bqyhk": "当期の返済額(USDT)",
    "hktips": "残高が十分であることを確認してください。残高が不足している場合は、最初に再充電してから返済してください",
    "bj": "主要",
    "jie": "借りる",
    "ljhk": "すぐに返済",
    "qcz": "預け入れる",
    "yebzqxcz": "残高が不足している場合は、最初に再充電してから返済してください",
    "znj": "延滞料",
    "yqts": "延滞日数"
  },
  "hkxq":{
    "dd":"注文",
    "fzhkdz":"返済先住所をコピーする",
    "hkxq": "返済の詳細",
    "zlx": "総利息",
    "zhk": "総返済",
    "hkjg": "返済機関",
    "qschkpz": "返済証明書をアップロードしてください",
    "hkpz": "返済証明書"
  },
  "bbjyNew":{
    "jylx": "の種類",
    "jyze": "額"
  },
  "bind":{
    "title": "電子メール認証",
    "ybd": "バウンド",
    "wbd": "アンバウンド",
    "ts": "アカウントを保護するために、メールアドレスをバインドすることをお勧めします",
    "qsryxdz": "メールボックス番号を入力してください"
  },
  "tipsNew": {
    "yjj": "拒否されました",
    "shz": "償還"
  },
  "newIndex2": {
    "zxhy": "最新の引用",
    "jypt": "取引プラットフォーム",
    "ssyc": "シュリンクハイド",
    "hwzc": "まだ登録されていませんか？",
    "ljzc": "今すぐサインアップして、たくさんの機会を見つけてください！",
    "yyzh": "すでにアカウントをお持ちですか？",
    "hjbj": "アカウントをお持ちの場合はログインしてください。久しぶりです！",
    "lmdh": "列ナビゲーション",
    "ghdjy": "より良い取引、より良い生活",
    "ghdjy02": "世界で最も革新的な暗号取引ハブがここにあり、数百の暗号通貨を指先で購入、取引、獲得できます。",
    "indexCont01": "常にあなたのそばに",
    "indexCont02": "スポット市場と証拠金市場を高度な資金調達オプション、超高速の実行、深い流動性で取引します。",
    "indexCont03": "強力なAPI",
    "indexCont04": "直感的なAPI、取引プラットフォーム、高度な注文オプションを使用して、ポジションを簡単に管理できます。",
    "indexCont05": "高品質のデジタルアセット",
    "indexCont06": "9年0事故",
    "indexCont07": "トップセキュリティリスク管理",
    "indexCont08": "最大25回レバレッジ",
    "indexCont09":"最大25倍のレバレッジでビットコインCFDを取引します。",
    "indexCont010": "安全保護区",
    "indexCont011": "深い流動性",
    "indexCont012": "当社の高度な独自のマルチマーケットオーダーブックテクノロジーは、流動性を高め、スプレッドを引き締め、滑りを減らします。",
    "indexCont013": "ユーザー設定",
    "indexCont014": "対象国",
    "indexCont015": "私たちの強み",
    "indexCont016": "スポットおよび証拠金市場を高度な資金調達オプション、超高速実行、および深い流動性で取引します。",
    "indexCont017": "安全な保管",
    "indexCont018": "コールドウォレットとマルチパーティ計算（MPC）テクノロジーの組み合わせを使用して、デジタル資産を管理しています。",
    "indexCont019": "安全第一",
    "indexCont020": "最新のテクノロジーを使用して、資金を安全に保ち、バグやエクスプロイトの試みに先んじています。",
    "indexCont021": "クイック引き出し",
    "indexCont022": "マルチパーティ計算を使用して、厳格なセキュリティ基準を維持しながら、24時間年中無休で迅速な引き出しを提供できます。",
    "indexCont023": "暗号通貨を購入、販売",
    "indexCont024": "世界で最も包括的で安全な取引プラットフォームに参加",
    "indexCont025": "ビットコイン、イーサリアム、XRP、および法定通貨または暗号通貨を使用する他の多くの暗号通貨を売買します。",
    "yqwj": "1000万以上",
    "dlzc": "ログインして登録",
    "yzm": "確認コード",
    "qrmm":"パスワードの確認"
  },
  "langNew2":{
    "flzq": "報酬ハブ",
    "qdjl": "サインイン報酬",
    "mrqdjl": "毎日のログイン報酬",
    "qd": "ログイン",
    "yqd": "サインインしました",
    "hdgz": "イベントルール",
    "qdjl2": "チェックイン記録",
    "qdcg": "サインイン成功",
    "yhd": "取得",
    "lq": "受信",
    "dyt": "1日目",
    "det": "2日目",
    "dst": "3日目",
    "dsit": "4日目",
    "dwt": "5日目",
    "dlt": "6日目",
    "dqt": "7日目",
    "jxz": "進行中",
    "cjxnzh": "仮想アカウントを作成",
    "sy":"ホームページ",
    "sc":"市場",
    "sclb":"市場リスト",
    "jy":"取引",
    "zh":"口座",
    "db":"ローン",
    "zchm":"登録番号",
    "cp":"商品",
    "tzjd":"投資ローン",
    "zxzc":"オンラインサポート",
    "xd":"注文",
    "zzjptgmnr":"あなたの将来に投資しましょう。公正でオープンな金融システムでポートフォリオを成長させましょう。",
    "yy":"アプリ",
    "pqnr":"従来のルールを打破し、正確な財務管理ツールを提供するモバイルバンキング。",
    "jiami":"暗号通貨",
    "tgnr":"暗号通貨を使用して入金することで、セキュリティが強化され、取引処理が高速になります。",
    "jyl":"24 時間の取引量",
    "ssjmhb":"暗号通貨リスト",
    "zchy":"登録ユーザー",
    "djxz":"クリックしてダウンロード",
    "azsc":"Android Market",
    "pgsd":"Apple Store",
    "bqxx":'©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
  },
  // "langNew":{
  //   "szhb": "暗号通貨",
  //   "gjs": "金属",
  //   "yy": "原油",
  //   "jy": "トレード",
  //   "jmhb": "暗号通貨",
  //   "yxhy": "無期限契約",
  //   "gdjy": "未決注文",
  //   "khh": "口座銀行",
  //   "qsrkhh": "口座銀行を入力してください",
  //   "yhkh": "銀行カード番号",
  //   "qsryhkh": "銀行カード番号を入力してください",
  //  },
   "login":{
     login: '欢迎ログインする',
     msg: 'ログインしたアカウントを入力してください',
     list: ['携帯電話/Eメール', 'パスワード', 'パスワードを忘れましたか？', 'ログインする', 'アカウントがありません、今すぐログインしてください'],
     message: 'アカウントまたはパスワードを空にすることはできません',
     "cdlks":"まずはログインから始めましょう！",
     "zh":"アカウント",
     "qsrzh":"ユーザー名を入力して下さい",
     "mm":"パスワード",
     "qsrmm":"パスワードを入力する",
     "dl":"サインイン",
     "wjmm":"パスワードをお忘れですか",
     "qbdl":"ウォレットによるログイン",
     "myzh":"アカウントを持っていませんか?",
     "zc":"サインアップ",
     "yzm":"検証コード",
     "qsryzm":"確認コードを入力してください",
     "hqyzm":"コードが送信されました",
     "qrmm":"パスワードを認証する",
     "qsrqrmm":"パスワードを認証する",
     "lcmmbyz":"2 つのパスワード入力が矛盾しています",
     "mmts":"パスワードの長さは6～12文字です",
     "sjtx":"電話番号フォーマットエラー",
     "yxts":"メールフォーマットエラー",
     "qr":"わかりました",
     "sjzc":"携帯",
     "sjh":"電話番号",
     "qsrsjh":"電話番号を入力してください",
     "yqm":"招待コード（オプション）",
     "qsryqm":"招待コードを入力してください",
     "yxzc":"Eメール",
     "wyydbzx":"同意する",
     "yhxy":"《ユーザーサービス契約書》",
     "yhxy2":"ユーザーサービス契約書",
     "ysyx":"《プライバシー保護契約》",
     "yx":"Eメール",
     "qsryx":"メールアドレスを入力して",
     "yxgsbzc":"無効な電子メール",
     "cjmnzhcg":"デモアカウントが正常に作成されました",
     "tcmnzh":"デモ口座を終了する",
     "qbdlts":"DAPP ウォレットを使用してください。",
   },
  //  "index":{
  //    "xgnysx":"新機能がオンラインに登場！",
  //    "hyld":"受賞歴のある当社の金融取引プラットフォームへようこそ。世界の投資家とともに未来の金融世界を探索しましょう",
  //    "symncz":"デモ口座を使用する",
  //    "zdjyfy":"最低取引手数料 <0.3%",
  //    "jysyzc":"すべての資産を 1 か所で取引する",
  //    "hbsp":"外国為替、暗号通貨、株、指数、商品",
  //    "ksjy":"始める",
  //    "jdewd":"シンプルで安定した",
  //    "aizb":"ゴールデンAIトレーディング",
  //    "srjh":"ワンクリックで収入計画を作成",
  //    "kssy":"使い始める",
  //    "dlyhggdje":"低い金利と高額な金額",
  //    "jmhbdk":"仮想通貨ローン",
  //    "zmyrhdyp":"無担保で仮想通貨スポットを借りる",
  //    "gs":"会社",
  //    "gywm":"私たちについて",
  //    "xkzjd":"ライセンスの監督",
  //    "bzzx":"ヘルプセンター",
  //    "zhengce":"ポリシー",
  //    "tkytj":"利用規約",
  //    "yszc":"プライバシーポリシー",
  //    "sm":"声明",
  //    "flxx":"法律情報",
  //    "mzsm":"免責事項",
  //    "fxjg":"リスク警告",
  //    "gygg":"広告について",
  //    "gg":"発表",
  //  },
   "hq":{
     "wh":"外国為替",
     "szhb":"暗号",
     "gp":"ストック",
     "zs":"索引",
     "eft":"ETF",
     "mc":"名前",
     "xs":"24時間％",
     "tb":"チャート",
     "jg":"価格",
   },
   "user":{
     "wdzh":"私のアカウント",
     "zh":"アカウント：",
     "dk":"ローン：",
     "sydbzj":"使用されるマージン：",
     "yqll":"期待利益：",
     "qtgn":"その他の機能",
     "cz":"デポジット",
     "tx":"撤回する",
     "dh":"交換",
     "zhyz":"KYC認証",
     "zhjl":"アカウント履歴",
     "yqhy":"友達を招待",
     "flzq":"福祉ゾーン",
     "ggmm":"パスワードを変更する",
     "sz":"設定",
     "cjwtjd":"よくある質問",
     "fzdz":"アドレスをコピーする",
     "sl":"量...",
     "qsrsl":"数量を入力してください",
     "dd":"取得 (USDT)：",
     "sczm":"バウチャーをアップロードする",
     "qsczm":"バウチャーをアップロードしてください",
     "tj":"提出する",
     "czjl":"入金記録",
     "ddh":"いいえ。",
     "wsh":"未レビュー",
     "ywc":"完了",
     "bz":"名前：",
     "sl2":"量：",
     "sj":"時間：",
     "srsl":"数量を入力してください...",
     "dd2":"得る：",
     "qskgzflhd":"福利厚生活動については随時公開していきますので、ぜひご注目ください",
     "hdlb":"イベント一覧",
     "ckxq":"詳細を見る",
     "wdjl":"私のご褒美",
     "yiji":"レベル1",
     "erji":"レベル2",
     "sanji":"レベル3",
     "je":"額",
     "sj2":"時間",
     "yyxz":"言語",
     "tcdl":"サインアウト",
     "je2":"金額 (USD)...",
     "qsrje":"金額を入力してください",
     "jsdz":"受信アドレス...",
     "qsrjsdz":"受信アドレスを入力してください",
     "sjdz":"実際の到着：",
     "sxf":"手数料：",
     "txsm1":"出金には 5% の手数料がかかり、入金される前にネットワーク ノードによって確認される必要があります。",
     "txsm2":"知らない人に仮想通貨を譲渡しないでください",
     "tz":"通知する",
     "wdyq":"私の招待状",
     "yhid":"UID",
     "hdjl":"米ドルの特典を獲得",
     "yqsm":"友達を招待して Ai 定量化に参加し、マイニング マシンをレンタルし、製品を取引して暗号通貨の報酬を獲得しましょう",
     "yqsy":"招待収入",
     "yqrs":"招待人数",
     "tgljyq":"リンク経由で招待する",
     "lj":"リンク",
     "yqm":"招待コード",
     "cbtb":"入金と出金",
     "jymx":"取引詳細",
     "yqhyjl":"友達招待の報酬",
     "aidd":"ゴールデンAIトレーディング注文",
     "jdls":"融資履歴",
     "etfdd":"ETF注文",
     "jmhbdd":"暗号通貨の注文",
     "whdd":"外国為替注文",
     "gpdd":"在庫注文",
     "qx":"キャンセル",
     "zc":"資産",
     "zzc":"総資産",
     "ky":"利用可能",
     "zh2":"変換済み (USDT)",
     "xzbz":"選択する：",
     "sztkts":"重要: セキュリティ センターにアクセスして、トランザクション パスワードを設定してください。",
     "jymm":"取引パスワード",
     "szjymm":"取引パスワードを設定する",
     "qsrjymm":"取引パスワード",
     "zdsl":"最小数量",
     "bq":"タグ(メモ)",
     "qsrbq":"タグを入力してください",
     "yhktx":"銀行振込",
     "yhmc":"銀行名",
     "qsryhmc":"銀行名を入力してください",
     "yhzh":"銀行口座",
     "qsryhzh":"銀行口座番号を入力してください",
     "gjhkdm":"スウィフトコード",
     "qsrgjhkdm":"SWIFTコードを入力してください",
     "yhdz":"銀行住所",
     "qsryhdz":"銀行の住所を入力してください",
     "skrxm":"支払者名",
     "qsrskrxm":"受取人の名前を入力してください",
     "skrdh":"受取人の電話番号",
     "qsrskrdh":"受取人の電話番号を入力してください",
     "skrdz":"受取人の住所",
     "qsrskrdz":"受取人の住所を入力してください",
     "tbjl":"出金記録",
     "fzcg":"正常にコピーされました",
     "aqzx":"セキュリティセンター",
     "yxrz":"メール認証",
     "ybd":"バウンド",
     "wbd":"バインドされていません",
     "yrz":"確認済み",
     "wrz":"認定されていません",
     "ts":"アカウントを保護するには、メール アドレスをバインドすることをお勧めします",
     "qsryxdz":"メールアドレスを入力して",
     "dlmm":"ログインパスワード",
     "mbwtsz":"セキュリティ問題の設定",
     "mbwt":"セキュリティの問題",
     "qtxda":"答えを記入してください",
     "zyts":"重要：",
     "zytsCont":"セキュリティの答えと確認コードは公開しないでください。パスワードを回復するのに役立つセキュリティの質問を覚えておいてください。",
     "qsrxmm":"新しいパスワードを入力",
     "sydqmmcz":"現在のパスワードでリセット",
     "zhmm":"パスワードを取得するためのセキュリティの問題",
     "ysz":"設定されています",
     "tg":"無視する",
     "qsrdlmm":"パスワードを入力してください",
     "bzxz":"選択する：",
     "zwsj":"データなし",
     "qd":"わかりました",
     "zsgd":"もっと見せる",
     "zdss":"最小ロットサイズ",
     "mnjy":"模擬取引",
     "sx":"フィルタリング",
   },
   "zb":{
     "tgdd":"AI による注文管理",
     "tgz":"拘留されて",
     "ysh":"償還されました",
     "shz":"償還中",
     "zq":"サイクル：",
     "tian":"日",
     "syl2":"利益率：",
     "rgjg":"定期購入価格：",
     "rgjg2":"定期購入価格",
     "xdsj":"注文時間：",
     "yhl":"利益を得た：",
     "syts":"残りの日数：",
     "sh":"償還",
     "syl":"利益率",
     "bz":"名前",
     "dl":"為替レート",
     "tgts":"開催日：",
     "tgsl":"ホスティング数量",
     "qsrtgsl":"ホスティング数量を入力してください",
     "dbxe":"単一トランザクションの制限",
     "ljtg":"今すぐホストする",
     "zztg":"保管資金",
     "yjjrsy":"今日の推定収益",
     "ljsy":"累計収入",
     "tgzdd":"保管中の注文",
     "ljzc":"今すぐ転送",
     "gz":"ルール",
     "cpzq":"製品サイクル",
     "gm":"買う",
     "ts":"重要",
     "shts":"現在償還手続き中のため、満期前に償還すると 5% の損失が発生します。 本当に引き換えますか?",
     "xgcs":"購入制限回数",
   },
   "dk":{
     "dk":"ローン",
     "dkzh":"ローン口座",
     "yzsf":"本人確認をして融資額を増やしましょう！",
     "ksyz":"検証を開始する",
     "wxj":"借りたいのですが…",
     "dkqx":"貸出期間（日数）：",
     "mrll":"日利率：",
     "lxze":"合計利息：",
     "dkts":"3日間は無利息、その後は利息を支払うことも可能",
     "xzj":"今すぐ借りる",
     "wyydbzx":"同意する",
     "dkfwxy":"《ローンサービス契約書》",
     "dkfwxy2":"ローンサービシング契約",
     "dkysxy":"ローンプライバシー契約",
     "dkjl":"融資履歴",
     "hth":"いいえ。",
     "yfk":"支出済み",
     "lx":"興味：",
     "zhke":"総返済額：",
     "znj":"支払い遅延手数料：",
     "znjl":"延滞料金率：",
     "yqts":"延滞日数：",
     "qhk":"返済するため",
     "tpsc":"クレジットローン（画像アップロード）",
     "fwxx":"住宅情報",
     "srzm":"収入証明書（雇用関係）",
     "yhmx":"銀行詳細",
     "zjz":"証明写真",
     "ljdk":"今すぐ借りる",
     "xm":"名前",
     "ndxm":"あなたの名前",
     "qsrndxm":"あなたの名前を入力してください",
     "gj":"国",
     "ndgj":"あなたの国",
     "qsrndgj":"あなたの国を入力してください",
     "dz":"住所",
     "nddz":"あなたの住所",
     "qsrnddz":"住所を入力してください",
     "csrq":"生年月日",
     "ndcsrq":"あなたの誕生日",
     "qsrndcsrq":"生年月日を入力",
     "dhhm":"電話番号",
     "nddhhm":"あなたの電話番号",
     "qsrnddhhm":"電話番号を入力してください",
     "zj":"書類",
     "sfzm":"ポジティブなアイデンティティ",
     "qscsfzm":"自分のアイデンティティのポジティブな側面をアップロードする",
     "sffm":"アイデンティティの反対",
     "qscsffm":"あなたの身分証明書の裏面をアップロードしてください",
     "ddqr":"注文の確認",
     "jk":"ローン：",
     "dkqx2":"融資期間：",
     "qrxd":"注文を確認する",
     "yhkxq":"返済期限の詳細",
     "hkqr":"返済確認",
     "yhk":"返済期限：",
     "jksj":"貸出時間：",
     "ljhk":"すぐに返済してください",
   },
   "jy":{
     "rq":"日付",
     "qqjy":"オプションレコード",
     "hyjy":"契約",
     "qqhy":"オプション",
     "dqwt":"保留中",
     'wtz':"委任中",
     "hyjl":"契約実績",
     "shou":"たくさん",
     "dk":"お：",
     "zhjg":"最新：",
     "jyfy":"取引手数料：",
     "kfsj":"営業時間：",
     "gg":"レバー：",
     "pl":"バッチ：",
     "kpj":"オープン価格：",
     "yk":"利益と損失：",
     "cd":"注文をキャンセルする",
     "jsj":"決済価格：",
     "fx":"方向：",
     "jgsj":"納期：",
     "gb":"近い",
     "jxxd":"続く",
     "xj":"制限：",
     "gm":"買う：",
     "sl":"量",
     "fy":"料金：",
     "tzbzj":"余白を調整する",
     "zyzs":"テイクプロフィットとストップロス",
     "pc":"クローズポジション",
     "mr":"買う",
     "zjbzj":"マージンを増やす",
     "jsbzj":"マージンを減らす",
     "yxhy":"契約取引：",
     "cc":"役職：",
     "cc2":"位置",
     "cwbzk":"ポジションマージン：",
     "zdzjbzj":"マージンの最大増加：",
     "zjbzj2":"マージンを増やす：",
     "qsrzbzj":"デポジットを入力してください",
     "yxhy2":"永久",
     "kp":"平らにすることもできる",
     "zhang":"開ける",
     "xj2":"限界",
     "zy":"利益確定",
     "zs":"ストップロス",
     "ssjyzl":"トランザクションタイプの検索",
     "ddb":"注文書",
     "di":"L：",
     "gao":"ひ：",
     "gb2":"子：",
     "fz":"分",
     "mai":"購入：",
     "zhang2":"上昇",
     "tie":"秋",
     "sy":"戻る",
     "kz":"強気",
     "kt":"弱気",
     "bndy":"以下にすることはできません",
     "sxbzj":"必要な保証金：",
     "ky":"利用可能：",
     "sj":"市場",
     "mc":"売る",
     "zxtzsl":"最小数量",
     "min":"最小額",
     "max":"最大額",
     "yebz":"残高不足",
     "ddz":"待っている",
     "wtzl":"手数料の額：",
     "wtjg":"手数料価格：",
     "ycd":"キャンセル",
     "lswt":"歴史的",
     "qsrzyjg":"テイクプロフィット価格を入力してください",
     "qsrzsjg":"ストップロス価格を入力してください",
     "ccsl":"ポジションの数：",
     "ccjg":"ポジション価格：",
     "ggbs":"複数を活用する：",
     "zy2":"利食い：",
     "zs2":"ストップロス：",
     "zje":"一時金：",
     "ss":"たくさん：",
     "kcjg":"オープン価格：",
     "bzjl":"証拠金率：",
     "lscc":"歴史的地位",
     "gmj":"購入金額：",
     "guadan":"未決注文",
     "dqjg":"現在の価格：",
     "gdjg":"未決注文価格：",
     "pcjg":"終値：",
     "ccsj":"ポジション保持時間：",
     "gdsj":"注文保留時間：",
     "pcsj":"閉店時間：",
     "fdjyk":"変動純損益",
     "pcsl":"締め切り数量",
     "qrpc":"ポジションクローズの確認",
     "ypc":"ポジションをクローズ",
     "ss2":"たくさん",
     "qsrss":"ロットサイズを入力してください",
   },
   "gjrz":{
     "sfyz":"KYC認証",
     "t1":"1. 8M 未満の JPG、JPEG、または PNG 形式の画像をサポートします。",
     "t2":"2. 身分証明書写真は鮮明である必要があり、変更やブロックは許可されません。 肖像、ID番号、名前がはっきりと見える必要があります。",
     "t3":"3. 写真は帽子をかぶらずに撮影する必要があり、化粧をしないことをお勧めします。 書類を持つ人の顔の特徴がはっきりと見え、腕全体が露出している必要があります。",
     "t4":"わかりました",
     "bh":"拒否する",
     "shz":"検討中",
     "shtg":"試験に合格しました",
     "nyrzcg":"正常に認証されました",
     "sczjz":"証明写真をアップロードする",
     "sczjzmz":"身分証明書の正面写真をアップロードしてください",
     "sczjbmz":"身分証明書の裏面の写真をアップロードしてください",
     "scgrqmz":"手持ちの身分証明書の写真をアップロードしてください",
     "gjlb":"国リスト",
     "qxzgjlb":"国/地域を選択してください",
     "zsxm":"本名",
     "qsrzsxm":"本名を入力してください",
     "zjlx":"証明書の種類：",
     "zjhm":"ID番号",
     "qsrzjhm":"ID番号を入力してください",
     "khh":"口座開設銀行",
     "qsrkhh":"口座開設銀行を入力してください",
     "yhkh":"銀行カード番号",
     "qsryhkh":"銀行カード番号を入力してください",
   },
   "status":{
     "statusText":['失敗','検討中','成功'],
   },
   "download":{
     "t1":"いつでもどこでもモバイル取引",
     "xz":"ダウンロード",
   },
   "langNew":{
     "szhb": "暗号通貨",
     "gjs": "金属",
     "ny": "エネルギー源",
     "yy": "原油",
     "jy": "トレード",
     "jmhb": "暗号通貨",
     "yxhy": "無期限契約",
     "gdjy": "未決注文",
     "khh": "口座銀行",
     "qsrkhh": "口座銀行を入力してください",
     "yhkh": "銀行カード番号",
     "qsryhkh": "銀行カード番号を入力してください",
     "mnzh":"デモ口座",
     "zjjypt":"最高の取引プラットフォーム",
     "brjmzndxq":"このソフトウェアは最高の技術的専門知識であらゆるニーズに対応します",
     "jx":"続く",
     "yssm":"プライバシーに関する声明",
     "fxqzc":"マネーロンダリング防止ポリシー",
     "jgxkz":"規制上のライセンス",
     "ckgd":"もっと",
     "gd":"もっと",
     "dd":"注文",
     "ckdd":"オーダーの表示",
     "yxdd":"永久",
     "qqdd":"オプション",
     "hand":"lたくさん= ",
     "lxwm":"お問い合わせ",
     "tpfzl":"ここに画像を配置するか、",
     "liulang":"ブラウズ",
     "zctpgs":"サポート: JPG、JPEG2000、PNG",
     "ysr":"月収",
     "ndysr":"あなたの月収",
     "qsrndysr":"月収を入力してください",
     "yqtzje":"投資見込額",
     "qsrtzje":"投資予定額を入力してください",
     "zszh":"リアルアカウント",
     "qdl":"サインインしてください",
     "zx":"お気に入り",
     "hkdz":"返済先住所",
     "dkje":"融資額：",
     "zlx":"利息総額：",
     "hkze":"返済総額：",
     "qcz":"入金へ進む",
     "yebz":"残高が不足しています。再チャージしてください",
     "dhje":"返済額：",
     "hkjl":"返済命令：",
     "hkje":"残高：",
     "kyye":"返済：",
     "qb": '全て',
     "lmc": "チェーン名：",
     "search": "検索",
     "mrjg":"価格",
     "lxkf":"連絡する",
     "wyj":"損害賠償",
     "yxsj":"進行中：",
     "jssj":"仕上げる：",
     "hksj":"返済：",
     "sysj":"残り時間：",
     "jkqx":"ローン期間：",
     "yq":"期限切れ：",
     "qqss":"オプション取引注文の有効期限が切れており、損失は次のとおりです。",
     "qqlr":"オプション取引注文の有効期限が切れており、利益は",
     "bz":"通貨",
     "dzje":"いただいた分量",
     "lxyxzc":"電子メールサポート",
   },
   "langNew9":{
   "dzje":"取引商品の市場動向",
   "lxyxzc":"デジタル取引の旅を始めましょう",
   "text1":"アカウントを作成して始めましょう",
   "text2":"友達を招待して FXSFC に参加して一緒にプレイしましょう",
   "text3":"アカウントにチャージしましょう",
   "text4":"複数の通貨のチャージをサポートしているため、すぐに取引を開始できます",
   "text5":"取引を開始しましょう",
   "text6":"さまざまな高品質の取引ペアから選択でき、FXSFC で楽しく取引できます",
    "text7":"友達を招待してUSDTを獲得しましょう",
    "text8":"友達を招待して簡単にUSDTを獲得しましょう",
    "text9":"ローン機能はオンラインです",
    "text10":"お金がないときはローンを申し込むことができ、最短で当日に融資されます",
   "text11":"すべての資産を取引する",
   "text12":"外国為替、暗号通貨、先物、ETFなど",
   },
   "bank":{
     "text1":"最も信頼できる財務管理プラットフォーム",
     "text2":"リアルタイムのニュースアラート",
     "text3":"金融業界に関するリアルタイムの情報を理解する",
     "text4":"理解し始める",
     "text5":"ニュース速報",
     "text6":"銀行を選択してください",
     "text7":"銀行カード",
     "text8":"額...",
     "text9":"銀行カードを追加する",
     "text10":"銀行口座",
     "text11":"銀行口座を入力してください",
     "text12":"カードID",
     "text13":"カード番号IDを入力してください",
     "text14":"銀行の国際コード",
     "text15":"銀行の国際コード",
     "text16":"電話番号を入力してください",
     "text17":"に追加",
     "text18":"銀行カードの削除",
     "text19":"実際の到着",
     "text20":"出金情報",
     "text21":"銀行カードの選択",
     "text22":"注意事項",
     "text23":"最低出金額:",
     "text24":"最低出金額に満たない場合、出金はできません",
     "text25":"• 資金の安全性を確保するため、アカウントのセキュリティ ポリシーが変更された場合やパスワードが変更された場合は、手動で出金を確認します。スタッフから電話またはメールで連絡が来るまでしばらくお待ちください。",
     "text26":"• 情報の改ざんや漏洩を防ぐため、コンピューターとブラウザーが安全であることを確認してください。",
     "text27":"• 出金する USD については、各操作ごとに、所有する出金ページに表示される資産の合計額が対応する出金額だけ減少します。",
     "text28":"出金記録",
     "text29":"法定通貨の種類",
   }
   // "langNew2":{
   //   "sy":"ホームページ",
   //   "sc":"市場",
   //   "sclb":"市場リスト",
   //   "jy":"取引",
   //   "zh":"口座",
   //   "db":"ローン",
   //   "zchm":"登録番号",
   //   "cp":"商品",
   //   "tzjd":"投資ローン",
   //   "zxzc":"オンラインサポート",
   //   "xd":"注文",
   //   "zzjptgmnr":"あなたの将来に投資しましょう。公正でオープンな金融システムでポートフォリオを成長させましょう。",
   //   "yy":"アプリ",
   //   "pqnr":"従来のルールを打破し、正確な財務管理ツールを提供するモバイルバンキング。",
   //   "jiami":"暗号通貨",
   //   "tgnr":"暗号通貨を使用して入金することで、セキュリティが強化され、取引処理が高速になります。",
   //   "jyl":"24 時間の取引量",
   //   "ssjmhb":"暗号通貨リスト",
   //   "zchy":"登録ユーザー",
   //   "djxz":"クリックしてダウンロード",
   //   "azsc":"Android Market",
   //   "pgsd":"Apple Store",
   //   "bqxx":'©Copyright  ' + window.GLOBAL.DEFAULT_YEAR + window.GLOBAL.LANG_TITLE.zh + '. All rights reserved.',
   // }
}



// WEBPACK FOOTER //
// ./src/lang/jp.js